import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { ArrowIcon } from "@common/assets/arrowIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function DropDownInput({ sortOptions, activeSorter, isOpen }: Props) {
  const { t } = useTranslation();
  return (
    <div
      className={classNames(styles.dropDownInput, {
        [styles.opened]: isOpen,
      })}
    >
      <p>{t(sortOptions[activeSorter])}</p>
      <ArrowIcon className={styles.icon} />
    </div>
  );
}

export { DropDownInput };
